import React from 'react';
export const infoIconWithDynamicColor = /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Build-A-Box",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-to-box-checkout",
  transform: "translate(-713.000000, -1099.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: "0",
  y: "0",
  width: "1920",
  height: "2985"
}), /*#__PURE__*/React.createElement("g", {
  id: "atom/icon/information",
  transform: "translate(714.000000, 1100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "var(--main-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: "8",
  cy: "8",
  r: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.93333333,6.4 L8,6.4 L8,12.2666667 M6.93333333,12.2688 L9.06666667,12.2688",
  id: "Shape",
  stroke: "var(--main-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "var(--main-color)",
  cx: "7.71111111",
  cy: "4",
  r: "1"
}))))));